module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cannedResponses":"Canned Responses","errorRetrieveSignature":"There was an error retrieving the email signature."},"es":{"cannedResponses":"Respuestas pre-configuradas","errorRetrieveSignature":"Hubo un error al obtener la firma del correo."}}')
  delete Component.options._Ctor
}
